/* LMM PDP Prototyp — Galerie, Menge, Sticky-Kaufleiste. Vanilla, keine Abhängigkeiten. */
(function () {
  'use strict';

  /* Galerie: Thumbnail-Klick tauscht Hauptbild.

     Gemessen (drei Produkte, kalter Cache): der ERSTE Klick auf ein Thumbnail
     brauchte 408-667 ms bis zum sichtbaren Wechsel, der zweite 0-10 ms. Grund:
     das Hauptbild in Galeriegroesse war bis zum Klick nie geladen - geladen war
     nur das 144px-Thumbnail. Vor dem ersten Klick waren 0 von 17 Galeriebildern
     geholt. Weil src und srcset am SELBEN <img> getauscht werden, bleibt dabei
     das alte Bild stehen; das Symptom ist also ein toter Klick, kein leerer
     Bildbereich.

     Gegenmassnahmen, alle NACH dem ersten Render - LCP und Erstladezeit bleiben
     unberuehrt, es wird nichts in Zoomaufloesung vorgeladen:
       1. Absicht  - pointerenter / focus / touchstart auf einem Thumbnail holt
                     dessen Zielbild sofort.
       2. Leerlauf - nach dem load-Ereignis holt requestIdleCallback die
                     uebrigen Galeriebilder nach, eines nach dem anderen.
       3. Decode   - das vorgeladene Bild wird gleich nach dem Laden dekodiert,
                     damit beim Klick keine Decodezeit mehr anfaellt. Der Tausch
                     selbst bleibt synchron und ist damit nie langsamer als
                     vorher. */
  var lmmBildCache = Object.create(null);
  function lmmVorladen(src, srcset, sizes) {
    var schluessel = srcset || src;
    if (!schluessel) return null;
    if (lmmBildCache[schluessel]) return lmmBildCache[schluessel];
    var im = new Image();
    im.decoding = 'async';
    if (sizes) im.sizes = sizes;
    if (srcset) im.srcset = srcset;
    if (src) im.src = src;
    /* Dekodieren, sobald die Bytes da sind: die Decodezeit faellt damit VOR den
       Klick. decode() wird bewusst nur angestossen und NIE abgewartet - in einem
       verborgenen Dokument loest es gar nicht aus, ein Warten darauf wuerde den
       Bildwechsel also verzoegern statt beschleunigen. */
    var entschluesseln = function () {
      if (im.decode) { try { im.decode().catch(function () {}); } catch (e) {} }
    };
    if (im.complete && im.naturalWidth > 0) entschluesseln();
    else im.addEventListener('load', entschluesseln, { once: true });
    lmmBildCache[schluessel] = im;
    return im;
  }

  document.querySelectorAll('[data-lmm-gallery]').forEach(function (gallery) {
    var mainWrap = gallery.querySelector('[data-lmm-gallery-main]');
    var main = mainWrap ? mainWrap.querySelector('img') : null;
    if (!main) return;
    var sizes = main.getAttribute('sizes') || '';
    var zoomBtnMain = gallery.querySelector('[data-lmm-zoom]');
    var mainVid = null;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-lmm-thumb]'));
    function zielBild(btn) {
      if (btn.dataset.lmmVideoSrc) return null;
      var im = btn.querySelector('img');
      return lmmVorladen(btn.dataset.src || (im && im.src) || '',
                         btn.dataset.srcset || '', sizes);
    }
    thumbs.forEach(function (btn, idx) {
      var absicht = function () { zielBild(btn); };
      btn.addEventListener('pointerenter', absicht);
      btn.addEventListener('focus', absicht);
      btn.addEventListener('touchstart', absicht, { passive: true });
      btn.addEventListener('click', function () {
        var img = btn.querySelector('img');
        if (!img) return;
        var vSrc = btn.dataset.lmmVideoSrc || '';
        var isFirst = (!vSrc && (idx === 0 || btn === thumbs[0]));
        thumbs.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
        /* Starter-/Lieferumfang-Overlay (.lmm-gallery__incbadge) sowie Flags/EEK
           nur auf dem Startbild (Bild 1) einblenden — auf den Galeriebildern 2..8 und Videos
           ausblenden, damit keine Spezifikationen, Masszeichnungen oder Videos verdeckt werden (Chris 28./29.10.2026). */
        if (mainWrap) {
          mainWrap.classList.toggle('is-subimage', !isFirst);
          mainWrap.classList.toggle('is-video', Boolean(vSrc));
          mainWrap.querySelectorAll('.lmm-gallery__incbadge, .lmm-gallery__flags, .lmm-gallery__eek').forEach(function (ov) {
            ov.hidden = !isFirst;
            ov.style.display = isFirst ? '' : 'none';
          });
        }
        if (vSrc && mainWrap) {
          main.hidden = true;
          main.style.display = 'none';
          if (zoomBtnMain) { zoomBtnMain.hidden = true; zoomBtnMain.style.display = 'none'; }
          if (!mainVid) {
            mainVid = document.createElement('video');
            mainVid.className = 'lmm-gallery__video';
            mainVid.controls = true;
            mainVid.playsInline = true;
            mainVid.preload = 'none';
            mainWrap.appendChild(mainVid);
          }
          mainVid.hidden = false;
          mainVid.style.display = 'block';
          if (btn.dataset.poster) mainVid.poster = btn.dataset.poster;
          if (mainVid.getAttribute('src') !== vSrc) {
            mainVid.src = vSrc;
          }
          try { mainVid.play().catch(function () {}); } catch (e) {}
          return;
        }
        if (mainVid) {
          try { mainVid.pause(); } catch (e) {}
          mainVid.hidden = true;
          mainVid.style.display = 'none';
        }
        main.hidden = false;
        main.style.display = '';
        if (zoomBtnMain) { zoomBtnMain.hidden = false; zoomBtnMain.style.display = ''; }
        zielBild(btn);
        main.src = btn.dataset.src || img.src;
        if (btn.dataset.srcset) main.srcset = btn.dataset.srcset;
        main.alt = img.alt || main.alt;
      });
    });
    if (thumbs.length > 1) {
      var nachladen = function () {
        var i = 0;
        var weiter = function () {
          if (i >= thumbs.length) return;
          zielBild(thumbs[i++]);
          if (i < thumbs.length) zielBild(thumbs[i++]);
          if (i >= thumbs.length) return;
          if (window.requestIdleCallback) window.requestIdleCallback(weiter, { timeout: 500 });
          else setTimeout(weiter, 80);
        };
        weiter();
      };
      if (document.readyState === 'complete') setTimeout(nachladen, 300);
      else window.addEventListener('load', function () { setTimeout(nachladen, 300); },
                                   { once: true });
    }
  });

  /* Mengen-Stepper */
  document.querySelectorAll('[data-lmm-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    wrap.querySelectorAll('[data-lmm-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.lmmQtyChange, 10) || 0;
        var next = (parseInt(input.value, 10) || 1) + step;
        var min = parseInt(input.min, 10) || 1;
        input.value = Math.max(min, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Sticky-Kaufleiste: sichtbar, sobald der Kaufbereich nach oben aus dem
     Viewport gescrollt ist — und ausgeblendet, sobald der Footer erscheint
     (v2: Leiste soll im Seitenende nicht dominant über dem Footer stehen). */
  var bar = document.querySelector('[data-lmm-sticky-bar]');
  var buybox = document.getElementById('lmm-buybox');
  if (bar && buybox && 'IntersectionObserver' in window) {
    var pastBuybox = false;
    var footerInView = false;

    var update = function () {
      var visible = pastBuybox && !footerInView;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      /* Versteckt: aus der Tab-Reihenfolge nehmen (a11y — kein Fokus auf die off-screen Leiste). */
      bar.inert = !visible;
    };

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          pastBuybox = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        });
        update();
      },
      { threshold: 0 }
    ).observe(buybox);

    var footer = document.querySelector('.lmm-footer');
    if (footer) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            footerInView = entry.isIntersecting;
          });
          update();
        },
        { threshold: 0 }
      ).observe(footer);
    }
  }

  /* Galerie-Lightbox: Klick auf Hauptbild oder Lupe öffnet die große Ansicht.
     Vanilla, keine Abhängigkeit/App. A11y: role=dialog, Fokusfalle, ESC/X/Backdrop,
     Pfeiltasten, Mobile-Swipe. Hi-Res (data-zoom, 1600px) wird ERST beim Öffnen
     geladen — kein Above-the-fold-Performance-Schaden. Alt-Texte werden übernommen. */
  document.querySelectorAll('[data-lmm-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-lmm-gallery-main] img');
    if (!mainImg) return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-lmm-thumb]'));
    var items = thumbs.length
      ? thumbs.map(function (b) {
          var im = b.querySelector('img');
          var vSrc = b.getAttribute('data-lmm-video-src') || '';
          return {
            videoSrc: vSrc,
            poster: b.getAttribute('data-poster') || (im && im.src) || '',
            src: vSrc || b.getAttribute('data-zoom') || b.getAttribute('data-src') || (im && im.src),
            srcset: b.getAttribute('data-zoom-srcset') || '',
            alt: (im && im.alt) || mainImg.alt
          };
        })
      : [{ videoSrc: '', poster: '', src: mainImg.getAttribute('data-zoom') || mainImg.src, srcset: mainImg.getAttribute('data-zoom-srcset') || '', alt: mainImg.alt }];
    items = items.filter(function (it) { return it.src; });
    if (!items.length) return;
    var multi = items.length > 1;

    var lb = null, img = null, lbVid = null, capEl = null, prevBtn = null, nextBtn = null, closeBtn = null;
    var idx = 0, lastFocus = null;

    function activeIndex() {
      var a = gallery.querySelector('[data-lmm-thumb].is-active');
      var i = a ? thumbs.indexOf(a) : 0;
      return i < 0 ? 0 : i;
    }
    function nachbarnVorladen() {
      if (!multi) return;
      [(idx + 1) % items.length, (idx - 1 + items.length) % items.length]
        .forEach(function (n) {
          if (!items[n].videoSrc) lmmVorladen(items[n].src, items[n].srcset || '', '92vw');
        });
    }
    function render() {
      var cur = items[idx];
      if (capEl) capEl.textContent = multi ? (idx + 1) + ' / ' + items.length : '';
      if (cur.videoSrc) {
        img.hidden = true;
        img.style.display = 'none';
        if (!lbVid) {
          lbVid = document.createElement('video');
          lbVid.className = 'lmm-lightbox__video';
          lbVid.controls = true;
          lbVid.playsInline = true;
          lbVid.preload = 'none';
          img.parentNode.insertBefore(lbVid, img.nextSibling);
        }
        lbVid.hidden = false;
        lbVid.style.display = 'block';
        if (cur.poster) lbVid.poster = cur.poster;
        if (lbVid.getAttribute('src') !== cur.videoSrc) lbVid.src = cur.videoSrc;
        try { lbVid.play().catch(function () {}); } catch (e) {}
        return;
      }
      if (lbVid) {
        try { lbVid.pause(); } catch (e) {}
        lbVid.hidden = true;
        lbVid.style.display = 'none';
      }
      img.hidden = false;
      img.style.display = '';
      lmmVorladen(cur.src, cur.srcset || '', '92vw');
      img.alt = cur.alt || '';
      if (cur.srcset) { img.sizes = '92vw'; img.srcset = cur.srcset; }
      img.src = cur.src;
      nachbarnVorladen();
    }
    function go(d) { idx = (idx + d + items.length) % items.length; render(); }
    function focusable() {
      return [closeBtn, prevBtn, nextBtn].filter(function (b) { return b && b.offsetParent !== null; });
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (multi && e.key === 'ArrowLeft') { e.preventDefault(); go(-1); return; }
      if (multi && e.key === 'ArrowRight') { e.preventDefault(); go(1); return; }
      if (e.key === 'Tab') {
        var f = focusable(); if (!f.length) { e.preventDefault(); return; }
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    function build() {
      if (lb) return;
      lb = document.createElement('div');
      lb.className = 'lmm-lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Produktbild in großer Ansicht');
      lb.hidden = true;
      var nav = multi
        ? '<button type="button" class="lmm-lightbox__nav lmm-lightbox__prev" data-lb-prev aria-label="Vorheriges Bild"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg></button>'
            + '<button type="button" class="lmm-lightbox__nav lmm-lightbox__next" data-lb-next aria-label="Nächstes Bild"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>'
        : '';
      lb.innerHTML =
        '<div class="lmm-lightbox__backdrop" data-lb-close></div>'
        + '<button type="button" class="lmm-lightbox__close" data-lb-close aria-label="Schließen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
        + '<figure class="lmm-lightbox__fig"><img class="lmm-lightbox__img" alt="" decoding="async">'
        + (multi ? '<figcaption class="lmm-lightbox__cap" data-lb-cap aria-live="polite"></figcaption>' : '')
        + '</figure>' + nav;
      document.body.appendChild(lb);
      img = lb.querySelector('.lmm-lightbox__img');
      capEl = lb.querySelector('[data-lb-cap]');
      prevBtn = lb.querySelector('[data-lb-prev]');
      nextBtn = lb.querySelector('[data-lb-next]');
      closeBtn = lb.querySelector('.lmm-lightbox__close');
      Array.prototype.forEach.call(lb.querySelectorAll('[data-lb-close]'), function (el) { el.addEventListener('click', close); });
      if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });
      lb.addEventListener('keydown', onKey);
      var x0 = null;
      var fig = lb.querySelector('.lmm-lightbox__fig');
      fig.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      fig.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (multi && Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    function open() {
      build();
      idx = activeIndex();
      render();
      nachbarnVorladen();
      lastFocus = document.activeElement;
      lb.hidden = false;
      document.documentElement.classList.add('lmm-lightbox-open');
      closeBtn.focus();
    }
    function close() {
      if (!lb || lb.hidden) return;
      if (lbVid) { try { lbVid.pause(); } catch (e) {} }
      lb.hidden = true;
      document.documentElement.classList.remove('lmm-lightbox-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    var zoomBtn = gallery.querySelector('[data-lmm-zoom]');
    if (zoomBtn) zoomBtn.addEventListener('click', open);
    mainImg.style.cursor = 'zoom-in';
    mainImg.addEventListener('click', open);
  });

  /* Energie-Modal: offizielles EPREL-Label-PNG. Lädt es nicht (EPREL down/Hotlink-Limit),
     blende das Bild aus und zeige den Fallback (Badge + Links) — KEIN Fake-Label. */
  (function () {
    var elimg = document.querySelector('[data-lmm-elabel-img]');
    if (!elimg) return;
    var onfail = function () {
      var fig = elimg.closest('.lmm-elabel__official');
      if (fig) { fig.hidden = true; } else { elimg.hidden = true; }
      var fb = document.querySelector('[data-lmm-elabel-fallback]');
      if (fb) fb.hidden = false;
    };
    elimg.addEventListener('error', onfail);
    if (elimg.getAttribute('src') && elimg.complete && elimg.naturalWidth === 0) onfail();
  })();

  /* Sticky-Kaufleiste: Mengen-Stepper + live mitrechnende Zwischensumme
     (Chris 2026-07-12). EINE Mengen-Wahrheit: das Hauptformular-Feld
     #lmm-qty-input — der Leisten-Stepper schreibt dorthin und feuert 'change',
     damit die Buybox-Zwischensumme (lmm-pdp-inline.js) synchron mitzieht.
     Preisbasis + MwSt.-Satz kommen aus [data-lmm-subtotal] (gleiche Quelle,
     gleiche Formel, gleiches de-DE-Format wie die Buybox). */
  (function () {
    var mainQty = document.getElementById('lmm-qty-input');
    var sbInput = document.querySelector('[data-lmm-sb-input]');
    if (!mainQty || !sbInput) return;
    var sub = document.querySelector('[data-lmm-subtotal]');
    var unitGross = sub ? parseFloat(sub.getAttribute('data-lmm-unit-gross')) : NaN;
    /* TUEV-02 (2026-08-16): 0 % ist ein gueltiger Satz (Schweiz, Norwegen). Das alte
       "|| 19" hat genau diesen Fall zurueck auf 19 % gedreht. */
    var vatRaw = sub ? parseFloat(sub.getAttribute('data-lmm-vat-rate')) : NaN;
    var vat = 1 + (isFinite(vatRaw) && vatRaw >= 0 ? vatRaw : 19) / 100;
    var netEl = document.querySelector('[data-lmm-sb-net]');
    var grossEl = document.querySelector('[data-lmm-sb-gross]');
    var eur = function (n) {
      return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    };
    var render = function () {
      var qty = Math.max(1, parseInt(mainQty.value, 10) || 1);
      if (sbInput.value !== String(qty)) sbInput.value = qty;
      if (!isFinite(unitGross) || !grossEl) return;
      var sum = qty * unitGross;
      /* Ohne Steuer im Markt rendert das Liquid gar keine Netto-Zeile — dann darf hier
         auch nichts erzwungen werden. */
      if (netEl) netEl.textContent = vat > 1 ? eur(sum / vat) + ' exkl. MwSt.' : '';
      grossEl.textContent = eur(sum) + (vat > 1 ? ' inkl. MwSt.' : ' ohne MwSt.');
    };
    var setQty = function (q) {
      mainQty.value = Math.max(1, q);
      mainQty.dispatchEvent(new Event('change', { bubbles: true }));
    };
    document.querySelectorAll('[data-lmm-sb-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty((parseInt(mainQty.value, 10) || 1) + parseInt(btn.getAttribute('data-lmm-sb-step'), 10));
      });
    });
    sbInput.addEventListener('input', function () {
      var v = parseInt(sbInput.value, 10);
      if (isFinite(v) && v >= 1) setQty(v);
    });
    sbInput.addEventListener('change', function () {
      var v = parseInt(sbInput.value, 10);
      setQty(isFinite(v) && v >= 1 ? v : 1);
    });
    ['input', 'change'].forEach(function (evt) { mainQty.addEventListener(evt, render); });
    render();
  })();
})();

/* Mobile-Akkordeons „Paket A" (Chris 26.07.2026): Die Bereiche unterhalb des
   Kaufbereichs sind mobil per CSS zugeklappt (.lmm-macc ohne .is-open) — hier
   nur der Toggle + das Oeffnen bei Anker-Spruengen (Chips, „Schnell prüfen",
   #hash-Deeplinks). Delegiert ans document, Guard gegen Doppel-Init; auf
   Desktop (≥990px) sind die Buttons inert und aria-expanded steht auf true. */
(function () {
  'use strict';
  if (window.__lmmPdpMaccInit) return;
  window.__lmmPdpMaccInit = true;

  var mq = window.matchMedia('(max-width: 989px)');

  function setBtn(card, open) {
    var btn = card.querySelector('[data-lmm-macc]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function syncAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.lmm-macc'), function (card) {
      setBtn(card, mq.matches ? card.classList.contains('is-open') : true);
    });
  }

  function openCard(card) {
    if (!card || card.classList.contains('is-open')) return;
    card.classList.add('is-open');
    setBtn(card, true);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lmm-macc]');
    if (btn && mq.matches) {
      var card = btn.closest('.lmm-macc');
      if (card) setBtn(card, card.classList.toggle('is-open'));
      return;
    }
    /* Anker-Klick in ein zugeklapptes Ziel: VOR dem nativen Scroll oeffnen. */
    var a = e.target.closest('a[href*="#"]');
    if (!a || !mq.matches) return;
    var href = a.getAttribute('href') || '';
    var hash = href.slice(href.indexOf('#') + 1);
    if (!hash) return;
    var target = document.getElementById(hash);
    if (target) openCard(target.closest('.lmm-macc'));
  });

  function openFromHash() {
    if (!mq.matches || !location.hash) return;
    var t = document.getElementById(location.hash.slice(1));
    if (t) openCard(t.closest('.lmm-macc'));
  }
  window.addEventListener('hashchange', openFromHash);

  if (mq.addEventListener) mq.addEventListener('change', syncAll);
  else if (mq.addListener) mq.addListener(syncAll);
  syncAll();
  openFromHash();
})();

/* Mitlaufender Kaufblock (Chris 2026-08-14): Auf Desktop (>=990px) laeuft der
   Preis-/Kaufbereich ([data-lmm-buysticky]) beim Scrollen mit, statt dass die
   obere Sticky-Kaufleiste einblendet (die ist auf Desktop per CSS aus; mobil
   bleibt die untere Leiste unveraendert). Technik: position:fixed + gleich
   hoher Platzhalter — position:sticky wuerde am Ende der Kaufbox stoppen,
   der Block soll aber die ganze Seite mitlaufen (Chris: darf Inhalte darunter
   ueberdecken). 19px = 18px Polster + 1px Rand aus .lmm-buysticky.is-pinned. */
(function () {
  'use strict';
  if (window.__lmmBuyStickyInit) return;
  window.__lmmBuyStickyInit = true;

  var wrap = document.querySelector('[data-lmm-buysticky]');
  if (!wrap) return;
  var mq = window.matchMedia('(min-width: 990px)');
  var RAND = 19;
  var ABSTAND = 14;
  var spacer = null;
  var pinned = false;
  var ticking = false;

  /* Schliessen-X + Abschalten (Chris 02.10.2026): Das X blendet den
     mitlaufenden Block dauerhaft aus (auf allen Produktseiten, gemerkt in
     localStorage, kein Cookie). Solange er aus ist, steht in der normalen
     Kaufbox unter der Zwischensumme ein kleiner Schalter zum Wiedereinschalten;
     wurde in dieser Seitenansicht umgeschaltet, bleibt der Schalter bis zum
     Seitenwechsel stehen. Ohne Speicherzugriff (privates Fenster, blockiert)
     gilt das X nur fuer die aktuelle Seite. Nur Desktop (CSS). */
  var KEY = 'lmm-buysticky-aus';
  function gemerkt() {
    try { return window.localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function merken(wert) {
    try {
      if (wert) window.localStorage.setItem(KEY, '1');
      else window.localStorage.removeItem(KEY);
    } catch (e) { /* Speicher gesperrt: gilt nur fuer diese Seite */ }
  }
  var aus = gemerkt();

  var schliessen = document.createElement('button');
  schliessen.type = 'button';
  schliessen.className = 'lmm-buysticky__close';
  schliessen.setAttribute('aria-label', 'Mitlaufende Kaufbox ausblenden');
  schliessen.title = 'Ausblenden';
  schliessen.innerHTML = '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg>';
  wrap.appendChild(schliessen);

  var zeile = document.createElement('div');
  zeile.className = 'lmm-buysticky__pref';
  zeile.hidden = !aus;
  var schalter = document.createElement('button');
  schalter.type = 'button';
  schalter.className = 'lmm-buysticky__switch';
  schalter.setAttribute('role', 'switch');
  schalter.innerHTML = '<span class="lmm-buysticky__track" aria-hidden="true"><span class="lmm-buysticky__knob"></span></span><span class="lmm-buysticky__label">Kaufbox beim Scrollen mitlaufen lassen</span>';
  zeile.appendChild(schalter);
  var wish = wrap.querySelector('.lmm-wish-pdp');
  if (wish && wish.parentNode) wish.parentNode.insertBefore(zeile, wish);
  else wrap.appendChild(zeile);

  function zeigeSchalter() {
    schalter.setAttribute('aria-checked', aus ? 'false' : 'true');
  }
  zeigeSchalter();

  var hinweisEl = null;
  var hinweisTimer = 0;
  /* Hinweis erscheint dort, wo die Karte eben stand (oben rechts unter dem
     Kopf) - unten waere er hinter dem Cookie-Banner verschwunden. */
  function hinweis(r) {
    if (!hinweisEl) {
      hinweisEl = document.createElement('div');
      hinweisEl.className = 'lmm-buysticky__toast';
      hinweisEl.setAttribute('role', 'status');
      document.body.appendChild(hinweisEl);
    }
    hinweisEl.style.top = kopfhoehe() + 'px';
    hinweisEl.style.right = Math.max(16, Math.round(window.innerWidth - r.right)) + 'px';
    hinweisEl.textContent = 'Ausgeblendet. Wieder einschalten: Schalter unter dem Button „In den Warenkorb“.';
    hinweisEl.classList.add('is-sichtbar');
    clearTimeout(hinweisTimer);
    hinweisTimer = setTimeout(function () { hinweisEl.classList.remove('is-sichtbar'); }, 5000);
  }

  function kopfhoehe() {
    var v = parseFloat(getComputedStyle(document.documentElement)
      .getPropertyValue('--lmmh-stickyh'));
    return (isFinite(v) ? v : 130) + ABSTAND;
  }

  function pin() {
    var r = wrap.getBoundingClientRect();
    spacer = document.createElement('div');
    spacer.setAttribute('data-lmm-buysticky-spacer', '');
    spacer.style.height = r.height + 'px';
    wrap.parentNode.insertBefore(spacer, wrap);
    document.documentElement.style.setProperty('--lmm-buysticky-top', kopfhoehe() + 'px');
    wrap.classList.add('is-pinned');
    wrap.style.top = kopfhoehe() + 'px';
    /* Runde 2 (Chris 14.08.): gepinnt ~20 % schmaler; rechtsbuendig verankert —
       der rechte Rand der Karte bleibt an Ort und Stelle, der gewonnene
       Freiraum entsteht links (weniger Ueberdeckung des Seiteninhalts). */
    var voll = r.width + RAND * 2;
    /* Runde 4 (Chris 14.08.): 0.8 -> 0.9 — bei 80 % ueberlappten sich auf
       schmaleren Monitoren Preis- und Energiespalte ("mach's bisschen breiter"). */
    var breite = Math.round(voll * 0.9);
    wrap.style.left = (r.left - RAND + (voll - breite)) + 'px';
    wrap.style.width = breite + 'px';
    pinned = true;
  }

  function unpin() {
    if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
    spacer = null;
    wrap.classList.remove('is-pinned');
    wrap.style.top = '';
    wrap.style.left = '';
    wrap.style.width = '';
    pinned = false;
  }

  function messen() {
    ticking = false;
    if (!mq.matches) { if (pinned) unpin(); return; }
    if (aus) { if (pinned) unpin(); return; }
    var grenze = kopfhoehe();
    var top = (pinned ? spacer : wrap).getBoundingClientRect().top;
    if (!pinned && top < grenze) pin();
    else if (pinned && top >= grenze) unpin();
    else if (pinned) wrap.style.top = grenze + 'px';
  }

  function anfordern() {
    /* Bewusst setTimeout statt requestAnimationFrame: rAF pausiert in nicht
       komponierten Tabs (Hintergrund/Preview) — der Zustand soll aber auch
       dort korrekt nachziehen. 16 ms entspricht einem Frame. */
    if (ticking) return;
    ticking = true;
    setTimeout(messen, 16);
  }

  schliessen.addEventListener('click', function () {
    var r = wrap.getBoundingClientRect();
    aus = true;
    merken(true);
    zeile.hidden = false;
    zeigeSchalter();
    if (pinned) unpin();
    hinweis(r);
  });
  schalter.addEventListener('click', function () {
    aus = !aus;
    merken(aus);
    zeigeSchalter();
    anfordern();
  });
  /* Umschalten in einem anderen Tab sofort uebernehmen */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    aus = e.newValue === '1';
    if (aus) zeile.hidden = false;
    zeigeSchalter();
    anfordern();
  });

  window.addEventListener('scroll', anfordern, { passive: true });
  window.addEventListener('resize', function () { if (pinned) unpin(); anfordern(); });
  if (mq.addEventListener) mq.addEventListener('change', anfordern);
  else if (mq.addListener) mq.addListener(anfordern);
  messen();
})();

/* === LMM-PDP-PROSE-SOFT-BR-2026-10-20 === */
/* Weiche Absatz-Umbrüche (<br><br>) in langen PDP-Beschreibungsabsätzen (.lmm-prose > p),
   tokensparsam für alle ~8.562 Artikel-Detailseiten (Chris 20.10.2026). */
(function () {
  'use strict';
  if (window.__lmmPdpSoftBrInit) return;
  window.__lmmPdpSoftBrInit = true;

  var ABBREV = {
    'z.b.':1,'u.a.':1,'ca.':1,'bzw.':1,'inkl.':1,'exkl.':1,'ggf.':1,'max.':1,'min.':1,
    'nr.':1,'art.':1,'vgl.':1,'usw.':1,'etc.':1,'d.h.':1,'i.d.r.':1,'sog.':1,'std.':1,
    'sek.':1,'mio.':1,'mrd.':1,'abb.':1,'tab.':1,'gem.':1,'lt.':1,'evtl.':1,'zzgl.':1,
    'bspw.':1,'o.ä.':1,'u.u.':1,'st.':1,'dr.':1,'prof.':1,'abs.':1,'ziff.':1,'fa.':1,'tel.':1,'str.':1
  };

  function stripTags(html) {
    return html.replace(/<[^>]+>/g, '').trim();
  }

  function splitSentencesHtml(s) {
    s = s.trim();
    var inTag = false, paren = 0, out = [], start = 0, n = s.length;
    for (var i = 0; i < n; i++) {
      var ch = s.charAt(i);
      if (ch === '<') { inTag = true; }
      else if (ch === '>') { inTag = false; }
      else if (!inTag) {
        if (ch === '(') paren++;
        else if (ch === ')' && paren > 0) paren--;
        else if ((ch === '.' || ch === '!' || ch === '?') && paren === 0) {
          var j = i + 1;
          while (j < n && '"\'»“”'.indexOf(s.charAt(j)) !== -1) j++;
          if (j < n && /\s/.test(s.charAt(j))) {
            var prev = stripTags(s.slice(Math.max(0, i - 16), i + 1));
            var parts = prev.split(/\s+/);
            var lastTok = (parts[parts.length - 1] || '').toLowerCase();
            var isAbbrev = ABBREV[lastTok] || /^\d+\.$/.test(lastTok) || /^[a-zäöü]\.$/.test(lastTok);
            if (!isAbbrev) {
              var k = j;
              while (k < n && /\s/.test(s.charAt(k))) k++;
              if (k < n) {
                var rest = s.slice(k);
                if (/^(?:<(?:strong|b|em|i|a|span)\b[^>]*>\s*)*[A-ZÄÖÜ0-9„"«]/.test(rest)) {
                  out.push(s.slice(start, j).trim());
                  start = k;
                  i = k - 1;
                }
              }
            }
          }
        }
      }
    }
    var tail = s.slice(start).trim();
    if (tail) out.push(tail);
    return out;
  }

  function formatParagraph(p) {
    if (p.querySelector('br')) return;
    var html = p.innerHTML;
    var plain = (p.textContent || '').trim();
    if (plain.length < 220) return;
    var sents = splitSentencesHtml(html);
    if (sents.length < 2) return;
    var lens = sents.map(function (x) { return stripTags(x).length; });
    var total = lens.reduce(function (a, b) { return a + b; }, 0);
    if (sents.length === 2) {
      if (lens[0] >= 70 && lens[1] >= 70) {
        p.innerHTML = sents[0] + '<br><br>' + sents[1];
      }
      return;
    }
    if (sents.length === 3) {
      if (total >= 480 && lens[0] >= 135 && lens[1] >= 135 && lens[2] >= 135) {
        p.innerHTML = sents[0] + '<br><br>' + sents[1] + '<br><br>' + sents[2];
        return;
      }
      var d1 = Math.abs(lens[0] - (lens[1] + lens[2]));
      var d2 = Math.abs((lens[0] + lens[1]) - lens[2]);
      if (d1 <= d2 && lens[0] >= 80) {
        p.innerHTML = sents[0] + '<br><br>' + sents[1] + ' ' + sents[2];
      } else if (lens[2] >= 80) {
        p.innerHTML = sents[0] + ' ' + sents[1] + '<br><br>' + sents[2];
      }
      return;
    }
    var chunks = [], cur = [], curLen = 0;
    for (var idx = 0; idx < sents.length; idx++) {
      cur.push(sents[idx]);
      curLen += lens[idx];
      var rem = 0;
      for (var r = idx + 1; r < lens.length; r++) rem += lens[r];
      if ((curLen >= 180 || cur.length >= 2) && rem >= 85) {
        chunks.push(cur.join(' '));
        cur = [];
        curLen = 0;
      }
    }
    if (cur.length) chunks.push(cur.join(' '));
    if (chunks.length > 1) p.innerHTML = chunks.join('<br><br>');
  }

  Array.prototype.forEach.call(document.querySelectorAll('.lmm-prose > p'), formatParagraph);
})();
